import Request from "@/common/net/request.js";
const request = new Request();
// 修改个人密码
export function updatePwdForOld(data) {
  return request.send({
    url: `/pmy/sys/user/pwd/by-old`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 修改个人密码 通过短信
export function updatePwdForMsg(data) {
  return request.send({
    url: `/pmy/sys/user/web/pwd/by-phone`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 获取短信验证码 修改密码时
export function getCodeMsg(phone) {
  return request.send({
    url: `/pmy/sys/sms/web/update-pwd?phone=${phone}`,
    method: "get",
  });
}
// 获取消息数量
export function getMessageNum() {
  return request.send({
    url: `/pmy/sys/web/msg/unread`,
    method: "get",
  });
}

// 获取我的消息
export function getMessageList(data) {
  return request.send({
    url: `/pmy/sys/web/msg/mine/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 读取消息
export function readNotice(data) {
  return request.send({
    url: `/pmy/sys/web/msg/read`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
